﻿import type { SourceReference } from "./types.js";

export const sourceCatalog: Record<string, SourceReference> = {
  SG_IRAS_INVOICING_CUSTOMERS: {
    id: "SG_IRAS_INVOICING_CUSTOMERS",
    country: "SG",
    authority: "Inland Revenue Authority of Singapore (IRAS)",
    title: "Invoicing Customers",
    url: "https://www.iras.gov.sg/taxes/goods-services-tax-%28gst%29/basics-of-gst/invoicing-price-display-and-record-keeping/invoicing-customers",
    summary:
      "Official GST invoicing guidance covering tax invoice timing, mandatory contents, simplified tax invoices, receipts, credit notes, and debit notes. Last updated 10 March 2026 on page.",
    updatedOn: "2026-03-10",
    accessedOn: "2026-04-09"
  },
  SG_IRAS_GST_REGISTRATION: {
    id: "SG_IRAS_GST_REGISTRATION",
    country: "SG",
    authority: "Inland Revenue Authority of Singapore (IRAS)",
    title: "Do I need to register for GST",
    url: "https://www.iras.gov.sg/taxes/goods-services-tax-%28gst%29/gst-registration-deregistration/do-i-need-to-register-for-gst",
    summary:
      "Official GST registration threshold guidance for retrospective and prospective basis, including the S$1 million threshold and the grace-period change effective 1 July 2025.",
    updatedOn: "2026-02-01",
    accessedOn: "2026-04-09"
  },
  SG_IRAS_GST_RESPONSIBILITIES: {
    id: "SG_IRAS_GST_RESPONSIBILITIES",
    country: "SG",
    authority: "Inland Revenue Authority of Singapore (IRAS)",
    title: "Responsibilities of GST-registered businesses",
    url: "https://www.iras.gov.sg/taxes/goods-services-tax-%28gst%29/basics-of-gst/responsibilities-of-a-gst-registered-business/38",
    summary:
      "Official operational responsibilities for GST-registered businesses, including current 9% GST obligations, record-keeping duties, and the InvoiceNow compliance programme.",
    updatedOn: "2026-03-09",
    accessedOn: "2026-04-09"
  },
  SG_IRAS_GST_INVOICENOW_FAQ: {
    id: "SG_IRAS_GST_INVOICENOW_FAQ",
    country: "SG",
    authority: "Inland Revenue Authority of Singapore (IRAS)",
    title: "Frequently Asked Questions for GST InvoiceNow Requirement",
    url: "https://www.iras.gov.sg/media/docs/default-source/uploadedfiles/gst/frequently-asked-questions-for-gst-invoicenow-requirement.pdf?sfvrsn=fb2849aa_24",
    summary:
      "Official IRAS FAQ on the GST InvoiceNow requirement. The 9 March 2026 FAQ states that newly incorporated businesses applying for voluntary GST registration start from 1 November 2025, all new voluntary GST registrations start from 1 April 2026, and the wider GST-registered base phases in from 1 April 2028 to 1 April 2031.",
    updatedOn: "2026-04-01",
    accessedOn: "2026-04-09"
  },
  SG_IRAS_INTL_SERVICES: {
    id: "SG_IRAS_INTL_SERVICES",
    country: "SG",
    authority: "Inland Revenue Authority of Singapore (IRAS)",
    title: "Providing International Services",
    url: "https://www.iras.gov.sg/taxes/goods-services-tax-%28gst%29/charging-gst-%28output-tax%29/when-to-charge-0-gst-%28zero-rate%29/providing-international-services",
    summary:
      "Official zero-rating guidance for international services. IRAS states that not all services to overseas customers can be zero-rated and the Section 21(3) conditions must be met.",
    updatedOn: "2026-02-01",
    accessedOn: "2026-04-09"
  },
  SG_IRAS_UEN_FORMAT: {
    id: "SG_IRAS_UEN_FORMAT",
    country: "SG",
    authority: "Inland Revenue Authority of Singapore (IRAS)",
    title: "IRAS API Services Interface Specifications",
    url: "https://file.go.gov.sg/sep-api-specs.pdf",
    summary:
      "Official IRAS API specification (version 1.6, last updated 7 January 2026) listing accepted UEN-BUSINESS, UEN-LOCAL COMPANY, and UEN-OTHERS formats.",
    updatedOn: "2026-01-07",
    accessedOn: "2026-04-09"
  },
  MY_HASIL_EINVOICE_TIMELINE: {
    id: "MY_HASIL_EINVOICE_TIMELINE",
    country: "MY",
    authority: "Lembaga Hasil Dalam Negeri Malaysia (HASiL)",
    title: "e-Invoice Implementation Timeline",
    url: "https://www.hasil.gov.my/en/e-invoice/implementation-of-e-invoicing-in-malaysia/e-invoice-implementation-timeline/",
    summary:
      "Official rollout schedule for Malaysia e-Invoice, including 1 January 2026 for turnover up to RM5 million. Taxpayers below RM1,000,000 may be exempt, but the broader FAQ should still be checked because not every below-RM1,000,000 case is automatically out of scope.",
    updatedOn: "2025-12-07",
    accessedOn: "2026-04-09"
  },
  MY_HASIL_EINVOICE_FAQ: {
    id: "MY_HASIL_EINVOICE_FAQ",
    country: "MY",
    authority: "Lembaga Hasil Dalam Negeri Malaysia (HASiL)",
    title: "LHDNM e-Invoice General FAQs",
    url: "https://www.hasil.gov.my/media/0xqitc2t/lhdnm-e-invoice-general-faqs.pdf",
    summary:
      "Official general FAQ clarifying that taxpayers with annual turnover below RM1,000,000 are generally exempt, but where exemption criteria are not met a concessionary implementation date of 1 July 2026 applies instead of assuming a blanket exemption.",
    updatedOn: "2026-03-05",
    accessedOn: "2026-04-09"
  },
  MY_MYINVOIS_INVOICE_V11: {
    id: "MY_MYINVOIS_INVOICE_V11",
    country: "MY",
    authority: "MyInvois SDK / HASiL",
    title: "Invoice v1.1",
    url: "https://sdk.myinvois.hasil.gov.my/documents/invoice-v1-1/",
    summary:
      "Official MyInvois invoice schema describing mandatory supplier, buyer, invoice core, tax, and line-item fields for Malaysia e-Invoice submissions.",
    updatedOn: "2026-03-01",
    accessedOn: "2026-04-09"
  },
  MY_MYINVOIS_VALIDATE_TIN: {
    id: "MY_MYINVOIS_VALIDATE_TIN",
    country: "MY",
    authority: "MyInvois SDK / HASiL",
    title: "Validate Taxpayer's TIN",
    url: "https://sdk.myinvois.hasil.gov.my/einvoicingapi/01-validate-taxpayer-tin/",
    summary:
      "Official API documentation for validating taxpayer TIN values before issuing Malaysia e-Invoices. Also used as the recommended authoritative TIN validation channel.",
    updatedOn: "2026-03-01",
    accessedOn: "2026-04-09"
  },
  MY_MYSST_BACKGROUND: {
    id: "MY_MYSST_BACKGROUND",
    country: "MY",
    authority: "Royal Malaysian Customs Department (MySST)",
    title: "Understanding SST / Background",
    url: "https://mysst.customs.gov.my/AboutBackground",
    summary:
      "Official SST overview page stating the current service tax rate schedule: 8% from 1 March 2024 except for F&B, parking, logistics, and telecommunications which remain at 6%.",
    updatedOn: "2026-02-08",
    effectiveFrom: "2024-03-01",
    accessedOn: "2026-04-09"
  },
  MY_MYSST_TAX_INVOICES: {
    id: "MY_MYSST_TAX_INVOICES",
    country: "MY",
    authority: "Royal Malaysian Customs Department (MySST)",
    title: "Issuing Invoices",
    url: "https://mysst.customs.gov.my/TaxInvoices",
    summary:
      "Official SST invoice page confirming that registered service-tax persons must issue invoices, in hard copy or electronically, containing prescribed particulars in Bahasa Melayu or English.",
    updatedOn: "2026-02-07",
    accessedOn: "2026-04-09"
  },
  MY_MYSST_RETURN_PAYMENT_GUIDE: {
    id: "MY_MYSST_RETURN_PAYMENT_GUIDE",
    country: "MY",
    authority: "Royal Malaysian Customs Department",
    title: "Service Tax Return and Payment Guide",
    url: "https://mysst.customs.gov.my/assets/document/1.%20Guide%20Service%20Tax%20Return%20and%20Payment_05092018.pdf",
    summary:
      "Official guide listing prescribed invoice particulars for service-tax invoices, including serial number, date, seller details, description, discount, totals excluding tax, tax shown separately, and totals including tax.",
    updatedOn: "2018-09-04",
    accessedOn: "2026-04-09"
  },
  MY_MYSST_REGISTRATION_TABLE: {
    id: "MY_MYSST_REGISTRATION_TABLE",
    country: "MY",
    authority: "Royal Malaysian Customs Department (MySST)",
    title: "Service Tax registration thresholds by service type",
    url: "https://mysst.customs.gov.my/assets/document/register/regBI.html",
    summary:
      "Official threshold table for taxable services. Relevant freelancer-friendly categories such as consultancy, legal, accounting, IT services, and advertising fall within the service tax registration schedule shown on the table.",
    updatedOn: "2026-04-07",
    accessedOn: "2026-04-09"
  },
  MY_MYSST_IT_GUIDE: {
    id: "MY_MYSST_IT_GUIDE",
    country: "MY",
    authority: "Royal Malaysian Customs Department",
    title: "Guide on Information Technology Services",
    url: "https://mysst.customs.gov.my/assets/document/Guide%20On%20IT%20Services.pdf",
    summary:
      "Official customs guide stating that IT services are taxable services, the RM500,000 threshold applies, every registered person must issue an invoice, and certain services connected with goods or land outside Malaysia are excluded.",
    updatedOn: "2018-08-25",
    accessedOn: "2026-04-09"
  },
  ID_DJP_PPN_COLLECTION: {
    id: "ID_DJP_PPN_COLLECTION",
    country: "ID",
    authority: "Direktorat Jenderal Pajak (DJP)",
    title: "Pemungutan Pajak Pertambahan Nilai",
    url: "https://stats.pajak.go.id/id/pemungutan-pajak-pertambahan-nilai",
    summary:
      "Official VAT collection overview stating that entrepreneurs with annual omzet of at least Rp4.8 billion must become PKP, though smaller businesses may opt in voluntarily.",
    updatedOn: "2025-07-01",
    accessedOn: "2026-04-09"
  },
  ID_DJP_FAKTUR_REGULATION: {
    id: "ID_DJP_FAKTUR_REGULATION",
    country: "ID",
    authority: "Direktorat Jenderal Pajak (DJP)",
    title: "PER-03/PJ/2022 Faktur Pajak",
    url: "https://www.pajak.go.id/index.php/id/peraturan/faktur-pajak",
    summary:
      "Official tax-invoice regulation page covering mandatory invoice contents, mandatory electronic form for PKP invoices, issuance timing, and the retail-consumer exception.",
    updatedOn: "2022-03-31",
    accessedOn: "2026-04-09"
  },
  ID_DJP_PPN_RATE: {
    id: "ID_DJP_PPN_RATE",
    country: "ID",
    authority: "Direktorat Jenderal Pajak (DJP)",
    title: "Kebijakan Baru PPN: tarif efektif 11% dan 12% barang mewah",
    url: "https://stats.pajak.go.id/en/node/113873",
    summary:
      "Official DJP article explaining that, from 1 January 2025, non-luxury goods and services remain effectively taxed at 11%, while luxury goods and services are taxed at 12%.",
    updatedOn: "2025-01-02",
    effectiveFrom: "2025-01-01",
    accessedOn: "2026-04-09"
  },
  ID_DJP_EXPORT_SERVICES: {
    id: "ID_DJP_EXPORT_SERVICES",
    country: "ID",
    authority: "Direktorat Jenderal Pajak (DJP)",
    title: "Ekspor Jasa Kena Pajak 0%",
    url: "https://www.pajak.go.id/index.php/en/node/34557",
    summary:
      "Official DJP publication stating that export of taxable services can use 0% VAT if the service is produced in Indonesia for use outside Indonesia and the formal conditions are met.",
    updatedOn: "2019-04-02",
    effectiveFrom: "2019-03-29",
    accessedOn: "2026-04-09"
  },
  ID_DJP_NPWP_16: {
    id: "ID_DJP_NPWP_16",
    country: "ID",
    authority: "Direktorat Jenderal Pajak (DJP)",
    title: "Peluncuran layanan perpajakan berbasis NIK / NPWP 16 digit",
    url: "https://www.pajak.go.id/index.php/id/siaran-pers/peluncuran-layanan-perpajakan-berbasis-nik-sebagai-npwp-npwp-16-digit-dan-nitku",
    summary:
      "Official DJP press release explaining NIK-as-NPWP for resident individuals and 16-digit NPWP usage for non-resident individuals, entities, and government institutions.",
    updatedOn: "2024-07-01",
    effectiveFrom: "2024-07-01",
    accessedOn: "2026-04-09"
  },
  ID_DJP_FAKTUR_CHANNELS: {
    id: "ID_DJP_FAKTUR_CHANNELS",
    country: "ID",
    authority: "Direktorat Jenderal Pajak (DJP)",
    title: "Keterangan Tertulis Penerbitan Faktur Pajak",
    url: "https://www.pajak.go.id/id/siaran-pers/penerbitan-faktur-pajak",
    summary:
      "Official DJP press release listing the currently supported issuance channels, including Coretax DJP, e-Faktur Client Desktop, and host-to-host via PJAP.",
    updatedOn: "2025-02-12",
    effectiveFrom: "2025-02-12",
    accessedOn: "2026-04-09"
  },
  TH_RD_VAT_OVERVIEW: {
    id: "TH_RD_VAT_OVERVIEW",
    country: "TH",
    authority: "Thailand Revenue Department",
    title: "Value Added Tax",
    url: "https://www.rd.go.th/english/6043.html",
    summary:
      "Official VAT overview page stating that a business becomes liable when its tax base exceeds THB 1.8 million per year, registration must be filed within 30 days, and zero-rate cases are separately prescribed.",
    updatedOn: "2020-11-23",
    accessedOn: "2026-04-09"
  },
  TH_RD_TAX_INVOICE_SECTIONS: {
    id: "TH_RD_TAX_INVOICE_SECTIONS",
    country: "TH",
    authority: "Thailand Revenue Department",
    title: "Revenue Code Sections 85/1, 86/4, 86/6 and 86/8",
    url: "https://www.rd.go.th/english/37741.html",
    summary:
      "Official English Revenue Code extracts listing mandatory particulars for tax invoices and abbreviated tax invoices, and stating that tax invoices should be in Thai language and THB unless Director-General approval is obtained.",
    accessedOn: "2026-04-09"
  },
  TH_RD_VAT_RATE_2026: {
    id: "TH_RD_VAT_RATE_2026",
    country: "TH",
    authority: "Thailand Revenue Department",
    title: "Extension of 7% VAT rate through 30 September 2026",
    url: "https://www.rd.go.th/region/08/chiangrai/265/3664.html",
    summary:
      "Official Revenue Department announcement confirming that the reduced 7% VAT rate remains in force through 30 September 2026 before returning to the statutory 10% rate unless extended again.",
    updatedOn: "2026-03-09",
    effectiveFrom: "2025-10-01",
    accessedOn: "2026-04-09"
  },
  TH_RD_TIN_SERVICE: {
    id: "TH_RD_TIN_SERVICE",
    country: "TH",
    authority: "Thailand Revenue Department",
    title: "Tax Identification Number service",
    url: "https://www.rd.go.th/42533.html",
    summary:
      "Official Revenue Department page stating that Thai tax identification numbers are 13 digits and can be checked through the department's online TIN services.",
    updatedOn: "2025-03-22",
    accessedOn: "2026-04-09"
  },
  TH_RD_ETAX_OVERVIEW: {
    id: "TH_RD_ETAX_OVERVIEW",
    country: "TH",
    authority: "Thailand Revenue Department",
    title: "e-Tax Invoice & e-Receipt overview",
    url: "https://etax.rd.go.th/etax_staticpage/app/emag/flipbook/01_Overview.pdf",
    summary:
      "Official e-Tax Invoice & e-Receipt overview describing the approved electronic issuance routes, including e-Tax Invoice by Time Stamp and e-Tax Invoice by Email for businesses with annual revenue not exceeding THB 30 million.",
    accessedOn: "2026-04-09"
  }
};

export const getSource = (id: string): SourceReference | undefined => sourceCatalog[id];
export const getSources = (ids: string[]): SourceReference[] =>
  ids.map((id) => sourceCatalog[id]).filter(Boolean) as SourceReference[];

